import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import AdmonitionComponent from './AdmonitionComponent';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    admonition: {
      setAdmonition: (type: 'note' | 'warning' | 'info' | 'tip') => ReturnType;
      toggleAdmonition: (type: 'note' | 'warning' | 'info' | 'tip') => ReturnType;
    };
  }
}

export const Admonition = Node.create({
  name: 'admonition',
  group: 'block',
  content: 'block+',
  marks: '',
  defining: true,
  draggable: true,

  addAttributes() {
    return {
      type: {
        default: 'note',
        parseHTML: (element) => element.getAttribute('data-type'),
        renderHTML: (attributes) => ({
          'data-type': attributes.type,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type]',
        contentElement: 'div:last-child',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ 'data-type': HTMLAttributes.type, class: 'admonition' }, HTMLAttributes),
      ['div', { class: 'admonition-title' }, 0],
      ['div', { class: 'admonition-content' }, 0],
    ];
  },

  addCommands() {
    return {
      setAdmonition: (type) => ({ commands }) => {
        return commands.setNode(this.name, { type });
      },
      toggleAdmonition: (type) => ({ commands }) => {
        return commands.toggleNode(this.name, 'paragraph', { type });
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(AdmonitionComponent);
  },
});
